import { isPlainObject } from 'lodash'

export function errorFromXhr({responseText}) {
  try {
    const { error } = JSON.parse(responseText)
    return isPlainObject(error) ? error : { error }
  } catch(e) {
    return { error: "A server error has occurred" }
  }
}